import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { getSupabase } from '@/lib/supabaseClient.js';

const ParentChildContext = createContext(null);

export function ParentChildProvider({ children }) {
  const { user } = useAuth();
  const supabase = getSupabase();
  const [linkedChildren, setLinkedChildren] = useState([]);
  const [selectedChildId, setSelectedChildId] = useState(null);

  useEffect(() => {
    const fetchLinks = async () => {
      if (!user || !supabase) return;
      const { data, error } = await supabase
        .from('parent_child_accounts')
        .select('child_id, permissions')
        .eq('parent_id', user.id);
      if (!error && data) {
        setLinkedChildren(data);
        if (data.length > 0 && !selectedChildId) {
          setSelectedChildId(data[0].child_id);
        }
      }
    };
    fetchLinks();
  }, [user, supabase, selectedChildId]);

  const value = {
    linkedChildren,
    selectedChildId,
    setSelectedChildId,
    isParent: linkedChildren.length > 0,
  };

  return (
    <ParentChildContext.Provider value={value}>
      {children}
    </ParentChildContext.Provider>
  );
}

export function useParentChild() {
  return useContext(ParentChildContext);
}
